import type { SVGProps } from "react";
export interface Receipt01IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Receipt01Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Receipt01IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3.132 19.125c.065.977.875 1.75 1.868 1.75h9.33a4.1 4.1 0 0 1-.449-1.75zM16.125 19a1.875 1.875 0 0 0 3.75 0V3.753l-1 .751a3.13 3.13 0 0 1-3.538.147l-.212-.147-1.6-1.2a.88.88 0 0 0-.928-.077l-.122.076-1.6 1.201a3.13 3.13 0 0 1-3.537.147l-.213-.147-1-.751v13.122H14c1.174 0 2.125.952 2.125 2.125m6 0a4.126 4.126 0 0 1-3.703 4.104l-.422.021H5A4.125 4.125 0 0 1 .875 19c0-1.173.952-2.125 2.125-2.125h.875V3.504c0-1.696 1.876-2.687 3.267-1.793l.133.092 1.2.901.121.076a.88.88 0 0 0 .929-.076l1.6-1.2.213-.146a3.12 3.12 0 0 1 3.537.146l1.6 1.2.122.076a.88.88 0 0 0 .927-.076l1.202-.9.131-.093c1.391-.895 3.268.096 3.268 1.793z"
      />
      <path
        fill={color}
        d="M16.997 11.87a1.125 1.125 0 0 1 .006 2.25l-4 .01a1.126 1.126 0 0 1-.006-2.25zm0-4a1.125 1.125 0 0 1 .006 2.25l-4 .01a1.125 1.125 0 0 1-.006-2.25zM10.374 13a1.375 1.375 0 0 1-2.742.14L7.625 13l.007-.141A1.375 1.375 0 0 1 9 11.626l.141.007c.693.07 1.233.655 1.233 1.367m0-4a1.374 1.374 0 0 1-2.742.141l-.007-.14.007-.141A1.375 1.375 0 0 1 9 7.625l.141.007A1.375 1.375 0 0 1 10.374 9"
      />
    </svg>
  );
}
